/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Cacher 
  var nbProductImages = document.querySelectorAll('.shopify-section--product .product-single__media-slide').length;
  if ( nbProductImages > 4 ){
    document.querySelector(".shopify-section--product .product-single__media-slider").insertAdjacentHTML("afterend", '<span class="voir-plus active">Voir plus</span>');
    var voirPlusBtn = document.querySelector(".voir-plus");
    voirPlusBtn.onclick = function(event) {
      if ( voirPlusBtn.classList.contains("active") === true ){
        voirPlusBtn.textContent = "Voir moins";
        voirPlusBtn.classList.remove("active");
        document.head.insertAdjacentHTML('beforeend', '<style>@media only screen and (min-width: 1024px) {.product-single__media-slide:nth-child(n+5){display: block;}}</style>');
      }else{
        voirPlusBtn.textContent = "Voir plus";
        voirPlusBtn.classList.add("active");
        document.head.insertAdjacentHTML('beforeend', '<style>@media only screen and (min-width: 1024px) {.product-single__media-slide:nth-child(n+5){display: none;}}</style>');
      }
    };
  }







  // Image de survol des cartes produit : Chrome ne charge pas une image lazy masquée par clip-path,
  // on la charge dès que la carte approche de l'écran (même logique que le lazy-load natif).
  var hoverImages = document.querySelectorAll('.product__media__hover img[loading="lazy"]');
  if (hoverImages.length && 'IntersectionObserver' in window) {
    var hoverObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.loading = 'eager';
        hoverObserver.unobserve(entry.target);
      });
    }, { rootMargin: '300px 0px' });
    var observeHoverImages = function (root) {
      root.querySelectorAll('.product__media__hover img[loading="lazy"]').forEach(function (img) { hoverObserver.observe(img); });
    };
    observeHoverImages(document);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) { if (node.nodeType === 1) observeHoverImages(node); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
